import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const initHeroMarqueeAnimation = () => {
  const marqueeBlocks = document.querySelectorAll(".wv-hero-marquee-block");

  if (!marqueeBlocks.length) return;

  marqueeBlocks.forEach((block) => {
    const subtitle = block.querySelector(".subtitle .hero-flip-item");
    const lines = block.querySelectorAll(".wv-hero-marquee-line");
    const pills = block.querySelectorAll(".wv-hero-marquee-pill");

    if (subtitle) {
      gsap.set(subtitle, {
        opacity: 0,
        y: 24,
      });
    }

    if (lines.length) {
      gsap.set(lines, {
        opacity: 0,
        y: 50,
      });
    }

    if (pills.length) {
      gsap.set(pills, {
        opacity: 0,
        scale: 0.96,
      });
    }

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: "top 80%",
        once: true,
      },
      defaults: {
        ease: "power3.out",
      },
    });

    if (subtitle) {
      tl.to(subtitle, {
        opacity: 1,
        y: 0,
        duration: 0.6,
      });
    }

    if (lines.length) {
      tl.to(
        lines,
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.12,
        },
        "-=0.2"
      );
    }

    if (pills.length) {
      tl.to(
        pills,
        {
          opacity: 1,
          scale: 1,
          duration: 0.45,
          stagger: 0.08,
        },
        "-=0.6"
      );
    }
  });
};

window.addEventListener("load", initHeroMarqueeAnimation);